import { Component, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {VendorInvoiceService} from '../../shared/services/vendor-invoice.service';
import {Observable, Subscription} from 'rxjs';
import {Utils} from '../../shared/utils/utils';
import {UserService} from '../../shared/services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {AssignmentService} from '../../shared/services/assignment.service';
import {IwgSelect} from '../../shared/Models/iwgselect.model';
import {IwgSelectService} from '../../shared/services/iwgselect.service';
import {VendorInvoiceLineItemService} from '../../shared/services/vendor-invoiceLineitms.service';
import { ListSearchParams } from 'src/app/shared/models/listsearchparams.model';
import { NgForm } from '@angular/forms';
import { DownloadService } from 'src/app/shared/services/download.service';
import { catchError } from 'rxjs/operators';
import {IWGSharedService} from '../../shared/services/shared.service';
import { ChargeSelectComponent } from 'src/app/iwgcommon/formelements/charge-select/charge-select.component';

@Component({
  selector: 'app-vendor-invoice-dialog',
  templateUrl: './vendor-invoice-dialog.component.html',
  styleUrls: ['./vendor-invoice-dialog.component.scss']
})
export class VendorInvoiceDialogComponent  implements OnInit {

  engagementCostTypesSimple = null;
  LineItemsAdded = false;
  EngagementCurrencyCode = null;
  EngagementCurrencySymbol = null;
  Label1 = null;
  Label2 = null;
  ProjectLevel1Codes = null;
  ProjectLevel2Codes = null;
  hasLevel1 = false;
  hasLevel2 = false;
    isEmbed = false;
  loadingengament = false;

  isLoading = false;
  myDate = new Date();

  isFileUploaded = false;
  existingVendorInvoiceId = null;
  loading = false;
  maxSteps = 5;
  selectedStepIndex = 0;
  addInprogress = false;
  isFileUploadInProgress = false;

  @ViewChild('vendorInvoiceStep1') vendorInvoiceStep1: NgForm;
  @ViewChild('vendorInvoiceStep2') vendorInvoiceStep2: NgForm;
  @ViewChild('vendorInvoiceStep3') vendorInvoiceStep3: NgForm;
  @ViewChild('chargeSelect') chargeSelect: ChargeSelectComponent;

  numberOfSteps = 4;
  state: ListSearchParams;
  isEditFromDetails = null;
  anchorScroll: any;
  preselectedAssignmentId = null;
  assignmentsSimple = [];
  file_upload: any;

  step1 = {
    title: '',
    selectedAssignment: null,
    selectedAssignmentId: null,
    pay_period: null ,
    is_show_pay_period: false,
    invoice_number: '',
    po_number: '',
    notes: '',
    status_id: 0,
    showProjects: false,
    selectedAssignmentSimple: null,
    vendor_invoice_id: null ,
    selectedAssignmentIdForProjects: null,
  };
  step2 = {
    job_description_file_id: '',
    offer_letter_file_id: '',
    line_items: [],
    new_title: '',
    new_pay_period: null,
    new_rate: 1,
    new_units: 0,
    new_total: 0,
    new_total_mask: '',
    allocation_id: 0,
    new_notes: '',
    show_unit: false,
    unit_disabled: true,
    show_rate: false,
    rate_disabled: true,
    unit_label: ' ',
    unit_label_plural: '',
    selectedCharge: null,
    show_bill_amount: false,
    chargeTypeDropDownEnabled: false,
    selectedAllocation: null,
    new_total_disabled: true,
    selectedAllocationId: null,
    selectProjectLevel1: null,
    selectProjectLevel2: null,
  };
  step3 = {
    attachmentFileName: '',
    description: '',
    attachments: null ,

  };
  step4 = {
  };
  q: any;
  assignmentsDef: any;
  existingVendorInvoice: any;

  vendorInvoice: any;
  Hposition: MatSnackBarHorizontalPosition = 'right';
  VPosition: MatSnackBarVerticalPosition = 'top';


  constructor(private dialog: MatDialog, private router: Router, utils: Utils, private vendorInvoiceService: VendorInvoiceService,
              userService: UserService, renderer: Renderer2,
              private assignment: IwgSelectService, private vendorInvoicelineitemService: VendorInvoiceLineItemService ,
              private route: ActivatedRoute, private assignmentService: AssignmentService,
              private dialogRef: MatDialogRef<VendorInvoiceDialogComponent>, private download: DownloadService,
              private toast: MatSnackBar, private sharedService: IWGSharedService,
              @Inject(MAT_DIALOG_DATA) private data: {
                existingInvoice: any,
              }
  ) {    
    if (data && data.existingInvoice) {
      this.existingVendorInvoice = data.existingInvoice;
    }
    this.loadAssignments();
  }

  ngAfterViewInit(){
    setTimeout(()=>{  
      this.isFileUploaded = false;
    },100); 
  }

  ngOnInit(): void {
    if (this.existingVendorInvoice) {
      if (this.existingVendorInvoice.Assignment) {
        this.preselectedAssignmentId = this.existingVendorInvoice.Assignment.ID;
      } else {
        console.error('VendorInvoice ' + this.existingVendorInvoice.ID + ' does not have an assignment associated with it.');
      }
      this.populateForm(this.existingVendorInvoice);
    }
    this.sharedService.iwgfileuploaded.subscribe((data) => {
      if ( !data ){
        return;
      }
      this.isFileUploaded = true;
    });

    // For reloading page after save
    if (!this.state || !this.state?.service) {
      this.state = {service: 1, global_scope: 1, limit: 25, page: 1};
      }
      this.isEmbed = this.sharedService.getIsEmbed();
  }

  selectAssignment(assignmentId) {
    if (assignmentId && this.assignmentsSimple) {     
      const q = this.assignmentsSimple.find(assignment => assignment.ID == this.preselectedAssignmentId);
      this.step1.selectedAssignmentSimple = q;
      if (!q) {
        console.error('Could not find assignment ID ' + this.preselectedAssignmentId + ' in the list of assignments');
      } else {
        this.postAssignmentChange(q);
      }
    }
  }

  onSelectedAllocationChange(newAllocation)  {

    if (newAllocation != null)
    {
      this.step2.selectedAllocationId = newAllocation.ID;
      this.step1.selectedAssignmentId = this.step1.selectedAssignmentIdForProjects;

      this.step2.chargeTypeDropDownEnabled = true;      
    }
  }


  onProjectLevel1Change(projectCode) {    
    if (projectCode != null) {
        this.step2.selectProjectLevel1 = projectCode.value;
        this.step1.selectedAssignmentId = this.step1.selectedAssignmentIdForProjects;

        this.step2.chargeTypeDropDownEnabled = true;
    }
  }

  onProjectLevel2Change(projectCode) {

    if (projectCode != null) {
        this.step2.selectProjectLevel2 = projectCode.value;
        this.step1.selectedAssignmentId = this.step1.selectedAssignmentIdForProjects;

        this.step2.chargeTypeDropDownEnabled = true;
    }
  }

  ChargeChange(newCharge){
    this.step2.new_units = 1;
    this.step2.new_rate = 0;

    this.step2.show_bill_amount = true;
    this.step2.new_total_disabled = true; // always disabled and based on calculations
    if (newCharge != null) {

        this.step2.show_unit = newCharge.IsUnitsVisible;
        this.step2.unit_disabled = (newCharge.IsUnitsEditable) ? false : true;
        this.step2.unit_label_plural = newCharge.RatePerLabelPlural;
        this.step2.unit_label = newCharge.RatePerLabelSingular;
        this.step2.show_rate = newCharge.IsRateVisible;
        this.step2.rate_disabled = (newCharge.IsRateEditable) ? false : true;
        if (newCharge.IsRateEditable == false) {
            this.step2.new_rate = newCharge.Amount;
            this.step2.new_total = this.step2.new_rate;            
            this.step2.new_total_mask = (this.EngagementCurrencySymbol || '') + ' ' + (this.step2.new_total || 0) + ' ' + (this.EngagementCurrencyCode || '');
        }
    }
    if (this.step2.show_unit == false && this.step2.rate_disabled)
    {
        this.step2.show_rate = false;
    }
    this.recalcAmount();
  }
  onNewRate(){
    this.recalcAmount();
  }
  onNewUnit(){
    this.recalcAmount();
  }
  recalcAmount()
  {
      this.step2.new_total = this.step2.new_rate * this.step2.new_units;
      this.step2.new_total_mask = (this.EngagementCurrencySymbol || '') + ' ' + (this.step2.new_total || 0) + ' ' + (this.EngagementCurrencyCode || '');
  }

  onSelectedAssignmentChange(newAssignment) {    
    if (newAssignment)
    {
      this.postAssignmentChange(newAssignment.value);
    }
  }

  postAssignmentChange(newAssignment) {   
    if (newAssignment)
    {
      this.step1.is_show_pay_period = newAssignment.ShowDeliveryDate;     
      if (!newAssignment.HasProjects)
      {
        this.step2.selectedAllocationId = 0;
        this.step1.selectedAssignmentId = newAssignment.ID;
        this.step2.chargeTypeDropDownEnabled = true;
        this.step1.selectedAssignmentIdForProjects = newAssignment.ID;
        this.step1.showProjects = false;
      } else {
        this.step1.selectedAssignmentIdForProjects = newAssignment.ID;
        this.step1.selectedAssignmentId = null; // wait to set this on the charge control until the allocation is set
        this.step1.showProjects = true;
      }
    }
  }

  nextStep(moveToNextStep): void {
    let canProceed = false;
    const stepIndex = this.selectedStepIndex + 1;

    switch (stepIndex) {
      case 1:
        canProceed = this.vendorInvoiceStep1.valid;
        break;
      case 2:
        canProceed = this.vendorInvoiceStep2 && this.vendorInvoiceStep2.valid;
        break;
      case 3:
        canProceed = this.vendorInvoiceStep3 && this.vendorInvoiceStep3.valid;
        break;
      case 4:
        break;
    }

    const skipSaving = (moveToNextStep && (stepIndex === 2 || stepIndex === 3));
    if (skipSaving) {
      const index = (this.selectedStepIndex === this.maxSteps) ? 0 : this.selectedStepIndex + 1;
      this.selectedStepIndex = index;
    } else if (canProceed || stepIndex === 2 || stepIndex === 3) {
      this.addInprogress = true;
      const index = (this.selectedStepIndex === this.maxSteps) ? 0 : this.selectedStepIndex + 1;
      this.saveDraft().then((response: any) => {
        this.addInprogress = false;
        this.loading = false;
        if (moveToNextStep) {
          this.selectedStepIndex = index;
        } else {
          this.UpdateLineItemsAndAttachments(location, this.anchorScroll);
        }
      }).catch(err => {console.log(err); });
    }
    this.resetFileErrorMessages();    
  }

  // let fileUploadDoRefreshListener = root.$on('iwg.file.upload.status', (event, data) => {
  //   this.isFileUploadInProgress = data;
  // });

  saveDraft() {
    // Draft status    
    const statusId = 5;
    return this.save(statusId);
  }

  save(statusId) {    

    this.loading = true;

    const props = {
      new_status_id: statusId
    };

    if (this.vendorInvoiceStep1.valid && !(this.vendorInvoiceStep2 && this.vendorInvoiceStep2.valid)){
      this.recalcAmount();
    }
    if (this.vendorInvoiceStep1.valid) {
      Object.assign(props, {
        title: this.step1.title,
        assignment_id: this.step1.selectedAssignmentSimple.ID,
        pay_period: this.step1.pay_period,
        invoice_number: this.step1.invoice_number,
        po_number: this.step1.po_number,
        notes: this.step1.notes,
      });
    }
    
    if (this.vendorInvoiceStep2 && this.vendorInvoiceStep2.valid) {

      Object.assign(props, {
        vendor_invoice_Id: this.step1.vendor_invoice_id,
        assignment_id: this.step1.selectedAssignmentSimple.ID,
        title: this.step2.new_title,
        pay_period: this.step2.new_pay_period,
        rate: this.step2.new_rate,
        // allocation_id: (this.step2.selectedAllocation != null) ? this.step2.selectedAllocation.ID : null,
        charge_id: this.step2.selectedCharge.ID,
        units: this.step2.new_units,
        notes: this.step2.new_notes,
        level1_id: (this.step2.selectProjectLevel1 != null) ? this.step2.selectProjectLevel1.ID : null,
        level2_id: (this.step2.selectProjectLevel2 != null) ? this.step2.selectProjectLevel2.ID : null
      });     
    }

    if (this.vendorInvoiceStep3.valid) {
      Object.assign(props, {
        description: this.step3.description,
        attachmentFileName: this.step3.attachmentFileName,
      });
    }

    // Edit or Create Invoice
    if (this.selectedStepIndex === 0) {
      if (this.existingVendorInvoiceId) {
        return this.vendorInvoiceService.update(this.existingVendorInvoiceId, props)
        .toPromise()
        .then(data => {this.onSaveSuccess(data); 
          this.sharedService.isStateChange.next(true);
          return data; })
        .catch(err => this.onSaveError(err));

      } else {
        return this.vendorInvoiceService.save(props)
        .toPromise()
        .then(data => {this.onSaveSuccess(data); this.sharedService.isStateChange.next(true);
          return data; })
        .catch(err => this.onSaveError(err));
      }
    }
    // Create New Invoice Line Item
    if (this.selectedStepIndex === 1) {
      return this.vendorInvoicelineitemService.create(this.existingVendorInvoiceId, props)
      .toPromise()
      .then(data => {this.onSaveSuccessLineItem(data); this.sharedService.isStateChange.next(true); return data; })
      .catch(err => this.onSaveError(err));

    }

    // Only used for submitting
    if (this.selectedStepIndex === 2) {
      return this.vendorInvoiceService.update(this.existingVendorInvoiceId, props)
      .toPromise()
      .then(data => {this.onSaveSuccessLineItem(data); this.sharedService.isStateChange.next(true);return data; })
      .catch(err => this.onSaveError(err));

    }
    if (this.selectedStepIndex === 3) {
      return this.vendorInvoiceService.update(this.existingVendorInvoiceId, props)
      .toPromise()
      .then(data => {this.onSaveSuccessLineItem(data); this.sharedService.isStateChange.next(true); return data; })
      .catch(err => this.onSaveError(err));
    }
  }

  downloadJobDescriptionFile = () => {
    this.download.saveAs('/Api/File/' + this.step2.job_description_file_id).then(() => {        
    });
  }

  downloadOfferLetterFile = () => {
    this.download.saveAs('/Api/File/' + this.step2.offer_letter_file_id).then(() => {          
      });
  }
  downloadFile(id): void{
    this.loading = true;
    this.download.saveAs('/Api/File/' + id).then(() => {
      this.loading = false;
    });
  }
  deleteInvoiceLineItem(id) {
    this.vendorInvoicelineitemService.delete(id).pipe(catchError((err) => {
      throw (err);
    }))
    .subscribe(result => {
      this.UpdateLineItemsAndAttachments(location, this.anchorScroll);
    },
    error => {
        console.log(error);
    });
  }

  deleteAttachment(attachmentId) {
    // tslint:disable-next-line:no-shadowed-variable
    this.vendorInvoiceService.deleteAttachment(this.existingVendorInvoiceId, attachmentId).pipe(catchError((err) => {
      throw (err);
    }))
    .subscribe(result => {
      this.UpdateLineItemsAndAttachments(location, this.anchorScroll);
    },
    error => {
        console.log(error);
    });
}

  UpdateLineItemsAndAttachments(location, anchorScroll): void {
    this.step2.new_title = '';
    this.step2.new_pay_period = null;
    this.step2.new_rate = 0;
    this.step2.new_units = 0;
    this.step2.new_total = 0;
    this.step2.new_total_mask = (this.EngagementCurrencySymbol || '') + ' 0 ' + (this.EngagementCurrencyCode || '');
    this.step2.new_notes = '';
    this.step2.selectedAllocation = null;
    this.step2.selectProjectLevel1 = null;
    this.step2.selectProjectLevel2 = null;

    this.step2.show_unit = false;
    this.step2.unit_disabled = true;
    this.step2.show_rate = false;
    this.step2.rate_disabled = true;
    this.step2.unit_label = '';
    this.step2.unit_label_plural = '';
    this.step2.selectedCharge = null;
    if (this.chargeSelect) {
      this.chargeSelect.resetControl();
    }
    this.step2.show_bill_amount = false;
    this.step2.chargeTypeDropDownEnabled = true;

    this.step3.description = '';
    this.step3.attachmentFileName = '';


    this.vendorInvoiceService.getVendorInvoiceById(this.existingVendorInvoiceId)
        .subscribe(returnVal => {
          const updatedVendorInvoice = returnVal.data.Data;          
          this.step2.line_items = updatedVendorInvoice.LineItems;
          this.step3.attachments = updatedVendorInvoice.Attachments;

          if (updatedVendorInvoice.Assignment.PayCurrency?.Abbreviation) {
            this.EngagementCurrencyCode = updatedVendorInvoice.Assignment.PayCurrency.Abbreviation;
            this.EngagementCurrencySymbol = updatedVendorInvoice.Assignment.PayCurrency.Symbol;
          }
          if (this.step2 && this.step2.line_items.length > 0) {
            this.LineItemsAdded = true;
          } else {
            this.LineItemsAdded = false;
          }
          //this.isFileUploaded = true;
    });


    // clear out validation errors
    if (this.vendorInvoiceStep2) {
      this.vendorInvoiceStep2.resetForm();
    }
    if (this.vendorInvoiceStep3) {
      this.vendorInvoiceStep3.resetForm();
    }
    // location.hash('AnchorLineItemReview');
    this.router.navigate(['/vendor-invoices'], { fragment: 'AnchorLineItemReview' });
    this.sharedService.iwgfileattached.next(true);
    this.isFileUploaded = false;
  }


onSaveError(error): void {
    this.loading = false;
    console.error(error);
  }

  onSaveSuccessLineItem(response): void {
    this.loading = false;
    // if (!response.ErrorCode != 200) {
    // }
    // $rootScope.$emit('iwg.vendorInvoice.change');
  }

  onSaveSuccess(response): void {
    this.loading = false;    
    this.existingVendorInvoiceId = response.data.Data.ID;
    if (response.data.ErrorCode != 200) {      
    } else if (response.data.Data) {
      if (response.data.Data && response.data.Data.ClientConfigLabel) {
        this.hasLevel1 = response.data.Data.ClientConfigLabel.hasLevel1;
        this.hasLevel2 = response.data.Data.ClientConfigLabel.hasLevel2;

        if (this.hasLevel1) {
            this.Label1 = response.data.Data.ClientConfigLabel.Lable1Name;
        }
        if (this.hasLevel2) {
            this.Label2 = response.data.Data.ClientConfigLabel.Lable2Name;
        }

        if (this.ProjectLevel1Codes || this.ProjectLevel2Codes == null) {
            this.ProjectLevel1Codes = response.data.Data.ProjectLevel1Codes;
            this.ProjectLevel2Codes = response.data.Data.ProjectLevel2Codes;
        }
      }

      if (this.EngagementCurrencySymbol || this.EngagementCurrencySymbol == null) {
        this.EngagementCurrencySymbol = response.data.Data.Assignment.PayCurrency.Symbol;
      }
      if (this.EngagementCurrencyCode || this.EngagementCurrencyCode == null) {
        this.EngagementCurrencyCode = response.data.Data.Assignment.PayCurrency.Abbreviation;
      }
    }   
  }

  objectComparison = function( option, value ) : boolean {
    if (!option || !value) {
      return false;
    }
    return option.ID === value.ID;
  }

  populateForm(existingVendorInvoice): void {    
    if (existingVendorInvoice) {
      if (existingVendorInvoice.Assignment && existingVendorInvoice.Assignment.PayCurrency
        && existingVendorInvoice.Assignment.PayCurrency.Abbreviation) {
        this.EngagementCurrencyCode = existingVendorInvoice.Assignment.PayCurrency.Abbreviation;
        this.EngagementCurrencySymbol = existingVendorInvoice.Assignment.PayCurrency.Symbol;
      }
      this.existingVendorInvoiceId = existingVendorInvoice.ID;
      this.step1.selectedAssignment = existingVendorInvoice.Assignment;
      this.step1.selectedAssignmentSimple = existingVendorInvoice.Assignment;

      this.postAssignmentChange(existingVendorInvoice.Assignment);

      Object.assign(this.step1, {
        title: existingVendorInvoice.Title,
        pay_period: existingVendorInvoice.PayPeriod ? new Date(existingVendorInvoice.PayPeriod) : null,
        invoice_number: existingVendorInvoice.InvoiceNumber,
        po_number: existingVendorInvoice.PONumber,
        notes: existingVendorInvoice.Notes,
        status: existingVendorInvoice.Status,
      });      
      if (existingVendorInvoice.LineItems) {
        Object.assign(this.step2, {
          line_items: existingVendorInvoice.LineItems,
        });
      }

      if (existingVendorInvoice.Attachments) {
        Object.assign(this.step3, {
          attachments: existingVendorInvoice.Attachments,
        });
      }

      Object.assign(this.step4, {});

      if (existingVendorInvoice.LineItems && existingVendorInvoice.LineItems.length > 0) {
        this.LineItemsAdded = true;
      }
    }
  }

  resetFileErrorMessages(): void {
    // Reset the error messages.
    // $rootScope.$emit('iwg.file.attached.reset');
    this.sharedService.iwgfileattachedreset.next(false);
    this.vendorInvoiceStep3.resetForm();
  }

  prevStep(): void {
    this.resetFileErrorMessages();
    this.selectedStepIndex -= 1;
  }

  canProceed(): boolean {
    const step = this.selectedStepIndex + 1;
    let valid = true;
    if (this['vendorInvoiceStep' + step]) {
      valid = this['vendorInvoiceStep' + step].valid;
    }
    if (step === 3 && !this.isFileUploaded) {
      valid = false;
    }
    return valid;
  }

  cancel(): void {
    this.dialogRef.close();
    if (this.selectedStepIndex > 0) {
      this.showConfirmationToast('Draft has been saved.');
      const redirectToServicePage = this.state.service == 2 ? 1 : 2; // Fix for refresh the page since servieId not used in SP
      
        if (this.sharedService.getIsEmbed() == true) {
          setTimeout(()=>{ 
            this.sharedService.sendPostMessageToParentWindow({ source: 3, service: 2 });
          },2000); //this.router.navigate(['/erwsdczxvendor-invoices'], { queryParams: { service: redirectToServicePage } });
        } else {
            this.router.navigate(['/vendor-invoices'], { queryParams: { service: redirectToServicePage } });
        }
    }
  }

  showConfirmationToast(text): void {
    this.toast.open(text, 'Got it', {
      duration: 2000, horizontalPosition: this.Hposition,
      verticalPosition: this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }

  submit() {
    const statusId = 6;
    this.save(statusId).then((response: any) => {      
      if (response.data.ErrorCode == 200) {
        this.dialogRef.close();
        this.showConfirmationToast('Thank you! Your invoice is now pending approval.');

        const redirectToServicePage = this.state.service == 2 ? 1 : 2; // Fix for refresh the page
          if (this.sharedService.getIsEmbed() == true) {
            setTimeout(()=>{   this.sharedService.sendPostMessageToParentWindow({ source: 3, service: 2 });
            },2000); //this.router.navigate(['/erwsdczxvendor-invoices'], { queryParams: { service: redirectToServicePage } });
          } else {
              this.router.navigate(['/vendor-invoices'], { queryParams: { service: redirectToServicePage } });
          }
      } else {
        if (response.data.ErrorCode == 406) {
          alert(response.data.Message.Details);
        } else {
          this.showConfirmationToast('Error submitting form.');          
        }
      }
    });
  }
  saveAsDraft(): void {
    this.saveDraft().then((response) => {
      if (response.data.ErrorCode == 200) {
        this.dialogRef.close();
        this.showConfirmationToast('Draft has been saved.');
        const redirectToServicePage = this.state.service == 2 ? 1 : 2;
          if (this.sharedService.getIsEmbed() == true) {
            setTimeout(()=>{  this.sharedService.sendPostMessageToParentWindow({ source: 3, service: 2 });
            },2000); //this.router.navigate(['/erwsdczxvendor-invoices'], { queryParams: { service: redirectToServicePage } });
          } else {
              this.router.navigate(['vendor-invoices'], { queryParams: { service: redirectToServicePage } });
          }
      } else {
        this.showConfirmationToast('Error saving draft.');
      }
    });
  }

  onOpen($event){
    if (!$event || this.assignmentsSimple.length > 0){
      return;
    }
    this.loadingengament = true;
    this.assignment.getAssignments({
      format_hint: 'US_AOR_assignment_list_drop_down'
    }).subscribe(
        data => {
          if (this.assignmentsSimple.length > 0){
            return;
          }
          this.assignmentsSimple = data.data.Data;          
          this.selectAssignment(this.preselectedAssignmentId);
          this.loadingengament = false;
        },
        err => {
          console.log('Error :: ', err);
        }
    );
  }
  loadAssignments(): void{
    this.assignment.getAssignments({
      format_hint: 'US_AOR_assignment_list_drop_down'
       }).subscribe(
        data => {
          this.assignmentsSimple = data.data.Data;         
          this.selectAssignment(this.preselectedAssignmentId);
        },
        err => {
          console.log('Error :: ', err);
        }
    );
  }

  canProceedSaveAndContinue = () => {
    const step = this.selectedStepIndex + 1;
    if (step == 2) {
        if (this.LineItemsAdded == true) {
            if ((this.step2.new_title && this.step2.new_title.trim() && this.step2.new_title.trim() !== '')
                || (this.step2.selectedCharge && this.step2.selectedCharge.ID)) {

                if (this.hasLevel1) {
                    if ((this.step2.selectProjectLevel1 && this.step2.selectProjectLevel1.ID)) {
                        return true;
                    }
                }
                if (this.hasLevel2) {
                    if ((this.step2.selectProjectLevel2 && this.step2.selectProjectLevel2.ID)) {
                        return true;
                    }
                }
                return false;
            } else {
                return true;
            }
        }
    }
    return true;
  }
}
